import { getCurrentApplicationId } from "~/lib/applicationId";

export type AdjustPlatform = "RenkaAndroid" | "HokageIos" | "CarinaIos";

/** Repro・Adjust イベント送信対象のネイティブアプリ applicationId */
const NATIVE_APPLICATION_IDS = new Set(["76", "93", "95"]);

export const isNativeApplication = (): boolean => {
  return NATIVE_APPLICATION_IDS.has(getCurrentApplicationId());
};

export const getCurrentAdjustPlatform = (): AdjustPlatform | null => {
  const appId = getCurrentApplicationId();
  switch (appId) {
    case "76":
      return "RenkaAndroid";
    case "93":
      return "HokageIos";
    case "95":
      return "CarinaIos";
    default:
      return null;
  }
};
